<template>
  <div class="ts-border-b ts-pb-2">
    <div class="ts-flex ts-space-x-2">
      <button
        @click="showCreateModal"
        class="ts-outline-none ts-bg-gray-100 ts-px-3 ts-py-2 ts-rounded focus:ts-outline-none hover:ts-bg-gray-500 ts-duration-150 hover:ts-text-white"
      >
        <i class="fas fa-user-plus"></i>
        {{ $t('paymentNotice.student') }}
      </button>
    </div>
    <a-drawer
      :title="$t('paymentNotice.createNewStudent')"
      :width="500"
      :visible="isCreateNewStudent"
      :body-style="{ paddingBottom: '80px' }"
      :zIndex="1024"
      @close="onClose"
    >
      <formCreateNewStudent @student-saved="onSavedStudent" />
    </a-drawer>
  </div>
</template>

<script>
import formCreateNewStudent from './form-create-new-student.vue'
export default {
  name: 'headerMenu',
  components: {
    formCreateNewStudent
  },
  data() {
    return {
      isCreateNewStudent: false
    }
  },
  methods: {
    showCreateModal() {
      this.isCreateNewStudent = true
    },
    onClose() {
      this.isCreateNewStudent = false
    },
    onSavedStudent(student) {
      this.$emit('student-save-success', student)
      this.isCreateNewStudent = false
    }
  }
}
</script>
